import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import Modal from 'shared/components/Modal';
import { actions } from 'actions';
import { track } from 'shared/utils/track';
import { lifecycle } from './actions';
import * as query from './query.gql';
import {
  selector,
  Selector,
  Data,
  OrderSubmitParamsQuery,
  OrderSubmitParamsQueryVariables,
  responseToProps,
} from './selectors';
import Form from './components/Form';

import './index.scss';
import PulseLoading from 'shared/components/PulseLoading';

export interface Props {}

type Enhanced = Props & Selector & typeof mapDispatchToProps & Data;

const b = b_.with('order-submit-modal');

const mapDispatchToProps = {
  close: () => actions.hideOrderSubmitModal(),
};

const enhance = compose<Enhanced, Props>(
  track(lifecycle),
  connect(selector, mapDispatchToProps),
  graphql<Props & Selector, OrderSubmitParamsQuery, OrderSubmitParamsQueryVariables, Data>(query, {
    props: responseToProps,
    options: ({ ideaId }) => ({ variables: { id: ideaId || 0 } }),
  })
);

class OrderSubmitModal extends React.Component<Enhanced> {
  render() {
    const { close, idea, min, max } = this.props;

    return (
      <Modal onClose={close} className={b()}>
        {!idea ? (
          <PulseLoading big />
        ) : (
          <Form idea={idea} min={min} max={max} initialAmount={min} />
        )}
      </Modal>
    );
  }
}

export default enhance(OrderSubmitModal);
